module.exports = __webpack_public_path__ + "static/story5-index-thumbnails-1920x1080-7d2a3d689299160dba2e968f127dc362.jpg";